import { cloneDeep } from 'lodash';
import ActionTypes from '../actions/actionTypes/index';

const _ = { cloneDeep };

const { COMPONENT_CONFIG_FETCH_SUCCESS, COMPONENT_CONFIG_RESET } = ActionTypes;

const initialState = {
    components: {
        'event-profile': null,
        'club-profile': null,
        'post-scores': null,
        dashboard: null,
        'side-menu': null,
        inbox: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case COMPONENT_CONFIG_FETCH_SUCCESS:
        {
            const newState = _.cloneDeep(state);
            const { component, config } = action.data;
            newState[component] = config;
            return newState;
        }
        case COMPONENT_CONFIG_RESET: {
            const newState = state;
            const { component } = action.data;
            newState[component] = null;
            return newState;
        }
        default:
            return state;
    }
};
